module.exports = "/lucky-balls/img/weager/balls/normal/LB_3.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_3.png
// module id = 1186
// module chunks = 0